module.exports = __webpack_public_path__ + "static/media/DaciaSpirit-Regular_V1000.41656578.eot";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/spirit/DaciaSpirit-Regular_V1000.eot
// module id = 653
// module chunks = 0